import { MobileBaseField } from '../BaseField/models';

export const MobileNumberField = MobileBaseField.extend({
    validation: {
        value: {
            pattern: 'number',
            required: function (val, attr, attrs) {
                return this._is_required(val, attr, attrs);
            }
        }
    }
});
